import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { wishlistAPI } from '../services/api';
import { useAuth } from './AuthContext';
import toast from 'react-hot-toast';

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [wishlist, setWishlist] = useState([]);

  const fetchWishlist = useCallback(async () => {
    if (!user) { setWishlist([]); return; }
    try {
      const { data } = await wishlistAPI.get();
      setWishlist(data);
    } catch { setWishlist([]); }
  }, [user]);

  useEffect(() => { fetchWishlist(); }, [fetchWishlist]);

  const toggleWishlist = async (productId) => {
    if (!user) { toast.error('Please login to use wishlist'); return; }
    const isInWishlist = wishlist.some(p => p._id === productId);
    try {
      if (isInWishlist) {
        const { data } = await wishlistAPI.remove(productId);
        setWishlist(data);
        toast.success('Removed from wishlist');
      } else {
        const { data } = await wishlistAPI.add(productId);
        setWishlist(data);
        toast.success('Added to wishlist');
      }
    } catch { toast.error('Failed to update wishlist'); }
  };

  const isWishlisted = (productId) => wishlist.some(p => p._id === productId);

  return (
    <WishlistContext.Provider value={{ wishlist, toggleWishlist, isWishlisted, fetchWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be used within WishlistProvider');
  return ctx;
};
